<template>
  <el-row
    class="pageSize"
    style="margin:0 auto;padding-top: 15px;"
    v-loading="loading"
  >

    <Head
      homeTitle="账号管理"
      id="accountInfo"
    ></Head>
    <el-form
      ref="accountInfo"
      :model="accountInfo"
      name="accountInfo"
      method="post"
    >
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col :span="23">
          <el-divider></el-divider>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="11"
          class="account_info"
        >基本信息</el-col>
        <el-col
          :span="11"
          class="account_info"
        >我的服务</el-col>
      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="2"
          class="account_font"
        >机构名称</el-col>
        <el-col
          :span="9"
          class="account_inputBox"
        >
          <el-input
            type="text"
            v-model="accountInfo.company"
          ></el-input>
        </el-col>
        <el-col
          :span="4"
          class="account_title"
        >[销售适当性]</el-col>
        <el-col :span="4"></el-col>
      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="2"
          class="account_font"
        >登录邮箱</el-col>
        <el-col
          :span="9"
          class="account_inputBox"
        >
          <el-input
            :disabled="true"
            type="text"
            v-model="accountInfo.email"
          ></el-input>
        </el-col>
        <el-col
          :span="2"
          class="account_font"
        >基金权限数</el-col>
        <el-col
          :span="8"
          class="account_inputBox"
        >
          <el-input
            :disabled="true"
            type="text"
            v-model="role.suitability"
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="2"
          class="account_font"
        >FTP目录</el-col>
        <el-col
          :span="9"
          class="account_inputBox"
        >
          <el-input
            type="ftpFolder"
            :disabled="true"
            v-model="accountInfo.ftpFolder"
          ></el-input>
        </el-col>
        <el-col
          :span="2"
          class="account_font"
        >服务截止</el-col>
        <el-col
          :span="8"
          class="account_inputBox"
        >
          <el-input
            type="text"
            :disabled="true"
            v-model="role.suitabilityDue"
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="2"
          class="account_font"
        >通讯地址</el-col>
        <el-col
          :span="9"
          class="account_inputBox"
        >
          <el-input
            type="text"
            v-model="accountInfo.address"
          ></el-input>
        </el-col>
        <el-col
          :span="4"
          class="account_title"
        >[基金排行榜]</el-col>
        <el-col></el-col>
      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="2"
          class="account_font"
        >主要联系人</el-col>
        <el-col
          :span="9"
          class="account_inputBox"
        >
          <el-input
            type="text"
            v-model="accountInfo.contact"
          ></el-input>
        </el-col>
        <el-col
          :span="2"
          class="account_font"
        >服务截止</el-col>
        <el-col
          :span="8"
          class="account_inputBox"
        >
          <el-input
            type="text"
            :disabled="true"
            v-model="role.rankingDue"
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="2"
          class="account_font"
        >联系方式</el-col>
        <el-col
          :span="9"
          class="account_inputBox"
        >
          <el-input
            type="text"
            v-model="accountInfo.phone"
          ></el-input>
        </el-col>
        <el-col
          :span="8"
          class="contact_font left_text_align click_link"
        >* 需要延长服务，请联系(0755)33110700或
          <el-link
            type="primary"
            href="mailto:chinamarketing@morningstar.com"
          >发送邮件</el-link>
        </el-col>

      </el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
        > </el-col>
        <el-col
          :span="4"
          class="left_text_align"
        >
          <el-button
            @click="dialogVisible = true"
            round
            size="small"
            style="font-size:14px;"
          >重置密码</el-button>
          <el-dialog
            id="account_dialog"
            title="重置密码注意事项"
            :visible.sync="dialogVisible"
            width="40%"
            center
          >
            <el-row class="margin-bottom-10"><span class="account_red">* </span><span>至少8个字符长</span></el-row>
            <el-row class="margin-bottom-10"><span class="account_red">* </span><span>包含至少一个（A-Z）字符以及一个数字或符号</span></el-row>
            <el-row class="margin-bottom-10"><span class="account_red">* </span><span>不包含4个或更多顺序或重复字符（例如AAAA或1234）</span></el-row>
            <el-row class="margin-bottom-10"><span class="account_red">* </span><span>不包含您的用户名,“ mstar”,“ MStar”或“ Morningstar”</span></el-row>
            <el-row class="margin-bottom-10">
              <el-col
                :span="5"     
                class="password_font"           
              >旧密码</el-col>
              <el-col
                :span="8"
                class="password_inputBox"
              >
                <el-input
                  type="text"
                  show-password
                  v-model="passwordInfo.oldPassword"
                ></el-input>
              </el-col>
            </el-row>
            <el-row class="margin-bottom-10">
              <el-col
                :span="5"     
                class="password_font"           
              >新密码</el-col>
              <el-col
                :span="8"
                class="password_inputBox"
              >
                <el-input
                  type="text"
                  show-password
                  v-model="passwordInfo.newPassword"
                ></el-input>
              </el-col>
            </el-row>   
            <el-row class="margin-bottom-10">
              <el-col
                :span="5"     
                class="password_font"           
              >确认新密码</el-col>
              <el-col
                :span="8"
                class="password_inputBox"
              >
                <el-input
                  type="text"
                  show-password
                  v-model="passwordInfo.confirmNewPassword"
                ></el-input>
              </el-col>
            </el-row>                     
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                round
                @click="dialogVisible = false"
              >取 消</el-button>
              <el-button
                round
                type="primary"
                @click="resetPassword"
              >确 定</el-button>
            </span>
          </el-dialog>
        </el-col>
        <el-col :span="6">
          <el-button
            @click="recoverData"
            round
            size="small"
            style="font-size:14px;"
            class="button_space"
          >恢 复</el-button>
          <el-button
            type="primary"
            round
            size="small"
            class="button_space"
            style="font-size:14px;"
            @click="editInformation(accountInfo)"
          >保 存</el-button>
        </el-col>
        <el-col></el-col>
        <el-col></el-col>
      </el-row>
    </el-form>
  </el-row>

</template>
<script>
import { getInfo, editInfo, getResetPasswordLink, resetPassword} from "../../api/user";
import { Message } from "element-ui";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const getToken=componentsCommon.localStorage.getToken;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;

let Head = componentsCommon.Head;
export default {
    data() {
        return {
            role: {},
            loading: false,
            dialogVisible: false,
            accountInfo: {
                company: "",
                email: "",
                ftpFolder: "",
                address: "",
                contact: "",
                phone: "",
            },
            passwordInfo:{              
                oldPassword: "",
                newPassword: "",
                confirmNewPassword: ""
            }
        };
    },
    components: { Head },
    methods: {
        dbclick(row, event, column) {
            row.editable = !row.editable;
        },
        editInformation() {
            const self = this;
            self.loading = true;
            editInfo(self.accountInfo)
                .then((response) => {
                    Message({
                        message: "更新成功",
                        type: "success",
                        duration: 5 * 1000,
                    });
                    Message.close = function () {
                        //self.loadInfoData();
                    };
                })
                .finally((r) => {
                    self.loading = false;
                });
        },
        loadInfoData() {
            const self = this;
            self.loading = true;
            getInfo()
                .then((response) => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function () {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            self.accountInfo = result.data;
                            setNameAndValue(
                                "subscription",
                                result.data.subscription
                            );
                        }
                    }
                    self.loading = false;
                })
                .catch((err) => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function () {};
                })
                .finally((r) => {
                    self.loading = false;
                });
        },
        recoverData() {
            const self = this;
            self.loadInfoData();
            const roleInfo = getNameAndValue("info");
            if (roleInfo != undefined && roleInfo != null && roleInfo != "") {
                self.role = JSON.parse(roleInfo);
                self.role.suitability = self.role.suitability.length;
            }
        },
        resetPassword() {
            const self = this;
            if(self.passwordInfo.oldPassword == null ||self.passwordInfo.oldPassword == '')
            {
              Message({
                  message: "旧密码不能为空，请重试！",
                  type: "error",
                  duration: 2 * 1000,
              });
              Message.close = function () {};
              return;
            }
            
            if(self.passwordInfo.newPassword == null || self.passwordInfo.newPassword == '')
            {
              Message({
                  message: "新密码不能为空，请重试！",
                  type: "error",
                  duration: 2 * 1000,
              });
              Message.close = function () {};
              return;
            }

            if(self.passwordInfo.confirmNewPassword == null || self.passwordInfo.confirmNewPassword == '')
            {
              Message({
                  message: "新确认密码不能为空，请重试！",
                  type: "error",
                  duration: 2 * 1000,
              });
              Message.close = function () {};
              return;
            }

            if(self.passwordInfo.oldPassword == self.passwordInfo.confirmNewPassword)
            {
              Message({
                  message: "旧密码和新密码不能相同，请重试！",
                  type: "error",
                  duration: 2 * 1000,
              });
              Message.close = function () {};
              return;
            }

            if(self.passwordInfo.newPassword != self.passwordInfo.confirmNewPassword)
            {
              Message({
                  message: "新密码和确认新密码不一致，请重试！",
                  type: "error",
                  duration: 2 * 1000,
              });
              Message.close = function () {};
              return;
            }

            self.dialogVisible = false;
            resetPassword(self.passwordInfo)
                .then((response) => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function () {};
                    } else {
                        if (checkResponseStatus(result, self)) {                            
                            Message({
                            message: "密码已经修改！",
                            type: "success",
                            duration: 5 * 1000,
                            });
                            Message.close = function () {};
                        }
                    }
                    self.loading = false;
                })
                .catch((err) => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function () {};
                })
                .finally((r) => {
                    self.loading = false;
                });
        },
    },
    mounted() {
        this.recoverData();
    },
};
</script>
<style lang="scss">
@import "../../public/sass/common";
@import "../../public/sass/components/account";
</style>